import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { BendShiftStatisticsData } from '@/models/Charts/chartsData';
import { shiftsService } from '@/services/shifts.service';
import { devicesService } from '@/services/devices.service';
import { calculateMaxCuttingTime } from '../Charts/maxCuttingTime';
import { isNil } from '@/utils/misc';
import BendProductionModeTable from './BendProductionModeTable.vue';
import BendProductivityTable from './BendProductivityTable.vue';
import BendingFlowTable from './BendingFlowTable.vue';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendShiftStatistics',
  props: {
    data: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: BendShiftStatisticsData[] | null;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const coalescedData = computed(() => props.data ?? []);

/**
 * The overall KPIs have to show:
 * - When no shifts are selected:
 *     Shift models: all / Shifts: all / Hours: 24h/per device
 * - When all shifts are selected:
 * 		Shift models: all / Shifts: all / Hours: the hours of the selected shifts, i.e.,
 *  if there are devices that do not have the whole day assigned to shifts, this time will not be included.
 */
const shiftsSelected = computed(() =>
  props.widgetDefinition.shifts.length === 0
    ? shiftsService.store.getAllByDeviceIds(deviceIdsSelected.value)
    : shiftsService.store.getMatchingIds(props.widgetDefinition.shifts),
);

const deviceIdsSelected = computed(() =>
  props.widgetDefinition.deviceIds.length === 0
    ? devicesService.store.bendDevices().map((d) => d.deviceId)
    : props.widgetDefinition.deviceIds,
);

const differentShifts = computed(() => shiftsSelected.value.length);

const differentShiftModels = computed(
  () => new Set(shiftsSelected.value.map((s) => s.shiftModelId)).size,
);

const totalHours = computed(() =>
  calculateMaxCuttingTime(
    devicesService.store.deviceIdsToIds(deviceIdsSelected.value),
    shiftsService.store.getMatchingIds(props.widgetDefinition.shifts),
    props.widgetDefinition.timeFilter,
  ),
);

return { __sfc: true,props, t, coalescedData, shiftsSelected, deviceIdsSelected, differentShifts, differentShiftModels, totalHours, isNil, BendProductionModeTable, BendProductivityTable, BendingFlowTable }
}

})